import Link from "next/link";
import { getTopPosts } from "../posts";

export default function MostReadArticles({ limit = 3 }) {
  const top = getTopPosts(limit);
  return (
    <section className="rounded-xl border border-neutral-200 bg-white shadow-sm p-4 md:p-5">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-neutral-900">Most-read Articles</h3>
        <Link href="/blog" className="text-xs font-medium text-[#8200f4] hover:underline">View all</Link>
      </div>
      <ul className="space-y-3">
        {top.map((p) => (
          <li key={p.slug}>
            <Link href={`/blog/${p.slug}`} className="group block">
              <p className="text-sm font-medium text-neutral-800 group-hover:underline leading-snug">{p.title}</p>
              <p className="text-xs text-neutral-600 flex items-center gap-1 mt-1">
                <span>{new Date(p.date).toLocaleDateString()}</span>
                <span>•</span>
                <span>{p.readingTime}</span>
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
